
export const GET_USER_RESUMES = 'GET_USER_RESUMES';// 获取用户履历列表

export const CHANGE_ADDITIONAL_S_S = 'CHANGE_ADDITIONAL_S_S';//修改用户附加身价